import { Injectable } from "@angular/core";
import { NiceAsyncTypeaheadProvider, NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { lastValueFrom, map, Observable } from "rxjs";
import { FindOptionsDto } from "../../../../common/dto/find-options.dto";
import { PumpingVisitBillingTypes } from "../../models/pumping-visit-billing-types.model";
import { PumpingVisitTypes } from "../../models/pumping-visit-types.model";
import { PumpingVisitTypesApi } from "../pumping-visit-types.api";

@Injectable()
export class PumpingVisitTypesTypeaheadApi extends NiceAsyncTypeaheadProvider<PumpingVisitTypes> {
    public resource = "pumpingVisitTypes";

    private pageSize = 10;

    constructor(private pumpingVisitTypesApi: PumpingVisitTypesApi) {
        super();
    }

    public override async getById(id: number): Promise<PumpingVisitTypes> {
        return lastValueFrom(this.pumpingVisitTypesApi.getById(id));
    }

    public override search(
        searchQuery: string,
        page: number
    ): Observable<NiceAsyncTypeaheadSearchResult<PumpingVisitTypes>> {
        const dto: FindOptionsDto = {
            searchQuery,
            page,
            pageSize: this.pageSize
        };

        return this.pumpingVisitTypesApi.search(dto).pipe(
            map(result => ({
                items: result,
                nextPage: result.length === this.pageSize ? page + 1 : null
            }))
        );
    }

    public override format(item: PumpingVisitBillingTypes): string {
        return item.value || "-";
    }
}
